import React from "react";

import { Container, Day, Month, Name } from "./calendarDay.styled";

const CalendarDay = ({
  isSelected,
  month,
  day,
  name,
}: {
  isSelected?: boolean;
  month?: string;
  day?: number;
  name?: string;
}) => {
  return (
    <Container isSelected={isSelected}>
      <Month>{month}</Month>
      <Day  fontWeight="bold">{day}</Day>
      <Name>{name}</Name>
    </Container>
  );
};

export { CalendarDay };
